<template>
<div class="vcenter">
  <div style="fontSize: 24px;"> Scan QR code </div>
  <img style="fontSize: 18px; width: 250px; height: auto;" :src='qrCodeImg'><br><br>
  <div style="fontSize: 16px; word-wrap: break-word;"> {{mfaCode}}</div><br>
  <el-button size="small" type="primary" style="font-family: Calibri; font-size: 15px; font-weight: 200; background: #202c4c;"  @click="next()">Next</el-button>
</div>
</template>
<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default({
  name: 'QR',
  data() {
    return {
      mfaCode: '',
      qrCodeImg: ''
    }
  },
  mounted(){
    this.mfaCode = sessionStorage.getItem('mfaCode')
    this.qrCodeImg = sessionStorage.getItem('qrCodeImg')
  },
  methods: {
    next() {
      sessionStorage.removeItem('qrCodeImg')
      sessionStorage.removeItem('mfaCode')
      
      this.$router.push({ name: 'softtoken' })
    }
  }

})
</script>

<style scoped>
.vcenter {
  position: absolute;
  margin: 0;
  top: 45%;
  left: 50%;
  -ms-transform: translate(-50%, -47%);
  transform: translate(-50%, -47%);
  width: 400px;
  color: #606266;
  background-color: #f2f2f2;
  border-radius: 5px;
  padding: 22px 22px;
  /* background: rgba(255, 255, 255, .9); */
  opacity: 0.96;
  box-shadow: 0 2px 6px 1px #666666;
  text-align: center;
}
</style>
